import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ValidationObserver",
    { ref: "observer" },
    [
      _c(
        VForm,
        {
          ref: "form",
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.buttonOnClick("submit")
            },
          },
          model: {
            value: _vm.fromIsValid,
            callback: function ($$v) {
              _vm.fromIsValid = $$v
            },
            expression: "fromIsValid",
          },
        },
        [
          _vm._t("label", function () {
            return [
              _c("p", [_vm._v("\n        " + _vm._s(_vm.label) + "\n      ")]),
            ]
          }),
          _vm._v(" "),
          _c(
            "div",
            { directives: [{ name: "debug", rawName: "v-debug" }] },
            [
              _c("h3", [_vm._v("\n        AtForm Debug Toggle\n      ")]),
              _vm._v(" "),
              _c(
                VBtnToggle,
                {
                  attrs: { label: "Debug", mandatory: "" },
                  model: {
                    value: _vm.dDebug,
                    callback: function ($$v) {
                      _vm.dDebug = $$v
                    },
                    expression: "dDebug",
                  },
                },
                [
                  _c(VBtn, { attrs: { value: true } }, [
                    _vm._v("\n          On\n        "),
                  ]),
                  _vm._v(" "),
                  _c(VBtn, { attrs: { value: false } }, [
                    _vm._v("\n          Off\n        "),
                  ]),
                  _vm._v(" "),
                  _c(VBtn, { attrs: { value: true } }, [
                    _vm._v("\n          (WIP) On (Persist)\n          "),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.dDebug
            ? _c(
                VAlert,
                { attrs: { type: "info", outlined: "" } },
                [
                  _c("div", { staticClass: "text-h6" }, [
                    _vm._v("\n        Debug\n      "),
                  ]),
                  _vm._v(
                    "\n      focusIndex ::" +
                      _vm._s(_vm.focusIndex) +
                      "\n      "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("JsonTextArea", {
                    attrs: { label: "fieldModel" },
                    model: {
                      value: _vm.fieldModel,
                      callback: function ($$v) {
                        _vm.fieldModel = $$v
                      },
                      expression: "fieldModel",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.fields, function (y, j) {
            return _c(
              VRow,
              { key: `form_element_${j}` },
              [
                _vm._l(y, function (x, i) {
                  return [
                    (x.show ? _vm.showCallback(x, _vm.fieldModel) : true) &&
                    _vm.appAllowAccess(
                      x.authenticated ? x.authenticated : false,
                      x.roles ? x.roles : [],
                      x.permissions ? x.permissions : []
                    )
                      ? _c(
                          "div",
                          {
                            key: `form_element_${j}_${i}`,
                            class: x.column + " py-1",
                          },
                          [
                            _c(
                              "input-rules-wrapper",
                              _vm._b(
                                {
                                  attrs: {
                                    rules: x.rules,
                                    value: _vm.tempData[`${j}_${i}`],
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({
                                          attrs,
                                          validateInput,
                                        }) {
                                          return [
                                            x.type === "section"
                                              ? _c(
                                                  "div",
                                                  [
                                                    _c(
                                                      "h2",
                                                      { class: x.class },
                                                      [
                                                        _vm._v(
                                                          "\n                  " +
                                                            _vm._s(x.title) +
                                                            "\n                "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(VDivider),
                                                  ],
                                                  1
                                                )
                                              : _c(
                                                  "div",
                                                  [
                                                    _vm._t(
                                                      x.data + "_top",
                                                      function () {
                                                        return [
                                                          x.labelHint
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  class:
                                                                    "text-subtitle-1 text-medium-emphasis " +
                                                                    x.class,
                                                                },
                                                                [
                                                                  _c("label", [
                                                                    _vm._v(
                                                                      "\n                      " +
                                                                        _vm._s(
                                                                          x
                                                                            .props
                                                                            .label
                                                                        ) +
                                                                        "\n                    "
                                                                    ),
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    VTooltip,
                                                                    {
                                                                      attrs: {
                                                                        right:
                                                                          "",
                                                                      },
                                                                      scopedSlots:
                                                                        _vm._u(
                                                                          [
                                                                            {
                                                                              key: "activator",
                                                                              fn: function (
                                                                                tt
                                                                              ) {
                                                                                return [
                                                                                  _c(
                                                                                    VIcon,
                                                                                    _vm._g(
                                                                                      _vm._b(
                                                                                        {
                                                                                          staticStyle:
                                                                                            {
                                                                                              "vertical-align":
                                                                                                "middle",
                                                                                            },
                                                                                        },
                                                                                        "v-icon",
                                                                                        tt.attrs,
                                                                                        false
                                                                                      ),
                                                                                      tt.on
                                                                                    ),
                                                                                    [
                                                                                      _vm._v(
                                                                                        "\n                          mdi-help-circle\n                        "
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              },
                                                                            },
                                                                          ],
                                                                          null,
                                                                          true
                                                                        ),
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              x.labelHint
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      },
                                                      null,
                                                      x
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.checkRegisteredComps(
                                                      x.component
                                                    )
                                                      ? _c(
                                                          x.component,
                                                          _vm._g(
                                                            _vm._b(
                                                              {
                                                                tag: "component",
                                                                scopedSlots:
                                                                  _vm._u(
                                                                    [
                                                                      _vm._l(
                                                                        _vm.scopedSlotNamesOnly,
                                                                        function (
                                                                          slot
                                                                        ) {
                                                                          return {
                                                                            key: _vm.fieldSlotName(
                                                                              slot,
                                                                              x.data
                                                                            ),
                                                                            fn: function (
                                                                              scope
                                                                            ) {
                                                                              return [
                                                                                _vm.isFieldSlot(
                                                                                  slot,
                                                                                  x.data
                                                                                )
                                                                                  ? [
                                                                                      _vm._t(
                                                                                        slot,
                                                                                        null,
                                                                                        null,
                                                                                        scope
                                                                                      ),
                                                                                    ]
                                                                                  : _vm._e(),
                                                                              ]
                                                                            },
                                                                          }
                                                                        }
                                                                      ),
                                                                    ],
                                                                    null,
                                                                    true
                                                                  ),
                                                              },
                                                              "component",
                                                              {
                                                                ...x.props,
                                                                label:
                                                                  x.labelHint
                                                                    ? undefined
                                                                    : x.props
                                                                    ? x.props
                                                                        .label
                                                                    : undefined,
                                                                ...attrs,
                                                                value:
                                                                  _vm.tempData[
                                                                    `${j}_${i}`
                                                                  ],
                                                              },
                                                              false
                                                            ),
                                                            {
                                                              input: (val) => {
                                                                validateInput(
                                                                  val
                                                                )
                                                                _vm.$set(
                                                                  _vm.tempData,
                                                                  `${j}_${i}`,
                                                                  val
                                                                )
                                                              },
                                                              focus: () => {
                                                                _vm.focusIndex = `${j}_${i}`
                                                              },
                                                              blur: () => {
                                                                _vm.focusIndex =
                                                                  null
                                                              },
                                                              keyup: (e) => {
                                                                _vm.focusNext(e)
                                                              },
                                                              uploadDone: (
                                                                e
                                                              ) => {
                                                                _vm.uploadDone =
                                                                  e
                                                              },
                                                            }
                                                          ),
                                                          [
                                                            _vm._v(" "),
                                                            _vm._l(
                                                              _vm.slotNamesOnly,
                                                              function (slot) {
                                                                return [
                                                                  _vm.isFieldSlot(
                                                                    slot,
                                                                    x.data
                                                                  )
                                                                    ? [
                                                                        _vm._t(
                                                                          slot
                                                                        ),
                                                                      ]
                                                                    : _vm._e(),
                                                                ]
                                                              }
                                                            ),
                                                          ],
                                                          2
                                                        )
                                                      : _vm._t(
                                                          x.component,
                                                          null,
                                                          {
                                                            row: _vm.fieldModel,
                                                            attrs: {
                                                              ...x.props,
                                                              label: x.labelHint
                                                                ? undefined
                                                                : x.props
                                                                ? x.props.label
                                                                : undefined,
                                                              ...attrs,
                                                              value:
                                                                _vm.tempData[
                                                                  `${j}_${i}`
                                                                ],
                                                            },
                                                            on: {
                                                              input: (val) => {
                                                                validateInput(
                                                                  val
                                                                )
                                                                _vm.$set(
                                                                  _vm.tempData,
                                                                  `${j}_${i}`,
                                                                  val
                                                                )
                                                              },
                                                              focus: () => {
                                                                _vm.focusIndex = `${j}_${i}`
                                                              },
                                                              blur: () => {
                                                                _vm.focusIndex =
                                                                  null
                                                              },
                                                              keyup: (e) => {
                                                                _vm.focusNext(e)
                                                              },
                                                              uploadDone: (
                                                                e
                                                              ) => {
                                                                _vm.uploadDone =
                                                                  e
                                                              },
                                                            },
                                                          }
                                                        ),
                                                  ],
                                                  2
                                                ),
                                            _vm._v(" "),
                                            _vm.dDebug
                                              ? _c(
                                                  VAlert,
                                                  {
                                                    attrs: {
                                                      dense: "",
                                                      type: "info",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "text-h6",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                  Debug: " +
                                                            _vm._s(
                                                              `${j}_${i}`
                                                            ) +
                                                            "\n                "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(
                                                      "\n                tempData ::" +
                                                        _vm._s(
                                                          _vm.tempData[
                                                            `${j}_${i}`
                                                          ]
                                                        ) +
                                                        "\n                "
                                                    ),
                                                    _c("br"),
                                                    _vm._v(
                                                      "\n                data::" +
                                                        _vm._s(x.data) +
                                                        "\n              "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                "input-rules-wrapper",
                                x,
                                false
                              )
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                }),
              ],
              2
            )
          }),
          _vm._v(" "),
          _vm._t("actions", function () {
            return [
              _c(
                VCardActions,
                [
                  _vm.mergeButton("cancel").show
                    ? _c(
                        "ActionButton",
                        _vm._b(
                          {
                            on: {
                              click: function ($event) {
                                return _vm.buttonOnClick("cancel")
                              },
                            },
                          },
                          "ActionButton",
                          _vm.mergeButton("cancel").props,
                          false
                        )
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.mergeButton("clear").show
                    ? _c(
                        "ActionButton",
                        _vm._b(
                          {
                            on: {
                              click: function ($event) {
                                return _vm.buttonOnClick("clear")
                              },
                            },
                          },
                          "ActionButton",
                          _vm.mergeButton("clear").props,
                          false
                        )
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.mergeButton("reset").show
                    ? _c(
                        "ActionButton",
                        _vm._b(
                          {
                            on: {
                              click: function ($event) {
                                return _vm.buttonOnClick("reset")
                              },
                            },
                          },
                          "ActionButton",
                          _vm.mergeButton("reset").props,
                          false
                        )
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(VSpacer),
                  _vm._v(" "),
                  _vm.mergeButton("submit").show
                    ? _c(
                        "ActionButton",
                        _vm._b(
                          { attrs: { type: "submit" } },
                          "ActionButton",
                          _vm.mergeButton("submit").props,
                          false
                        )
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }